<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      title="强制出车"
      :visible="dialogVisible"
      width="500px"
      @close="handleClose"
      center
      append-to-body
    >
      <el-form :model="form" ref="form" :rules="rules" label-width="80px">
        <el-form-item label="车牌号码" :prop="noPlateNumber ? '' : 'PlateNumber'">
          <el-col :span="18">
            <plate-panel
              :dialogVisible="dialogVisible"
              :noPlateNumber="noPlateNumber"
              @ok="getPlateNumber"
            ></plate-panel>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="noPlateNumber">无牌车</el-checkbox>
          </el-col>
        </el-form-item>
        <el-form-item label="车辆类型" prop="CarSize">
          <car-size-select
            ref="carSizeSelect"
            v-model="form.CarSize"
            @change="getCarSizeItem"
          ></car-size-select>
        </el-form-item>
        <el-form-item label="关闸车道" style="width: 100%" prop="OutGateId">
          <gateSelect
            ref="item"
            @change="getItem"
            :selectKey="'Id'"
            :Direction="0"
            :isDisabled="selectDisabled"
            v-model="form.OutGateId"
          />
        </el-form-item>
        <el-form-item label="出场类型">
          <el-select v-model="form.AbnormalType">
            <el-option
              v-for="(v, i) in statusOptions"
              :key="i"
              :value="v.value"
              :label="v.text"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开闸原因">
          <el-input v-model="form.Remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import platePanel from "./platePanel";
import showdialog from "@/minxs/showdialog";
import gateSelect from "@/serviceComponents/gateSelect";
import { closeGate } from "@/api/module/park";
import { voicePrompt } from '@/utils/voicePrompt'
import carSizeSelect from "@/serviceComponents/carSizeSelect";

export default {
  components: {
    platePanel,
    gateSelect,
    carSizeSelect,
  },
  props: {
    videoGateId: {
      type: Number,
      default: -1
    },
    selectDisabled: {
      type: Boolean,
      default: false
    }
  },
  mixins: [showdialog],
  data() {
    return {
      form: {
        PlateNumber: "",
        OutGateId: '',
        Remark: "",
        CarSize: 0,
        AbnormalType: undefined,
      },
      rules: {
        OutGateId: [
          { required: true, message: '请选择关闸车道', trigger: 'change' }
        ]
      },
      noPlateNumber: false,
      statusOptions: [
        {value: 1, text: '修改车牌'},
        {value: 2, text: '强制入场'},
        {value: 3, text: '强制出场'},
        {value: 4, text: '订单修改'},
        {value: 5, text: '入场关闸'},
        {value: 6, text: '出场关闸'},
        {value: 7, text: '修改车型'},
      ],
    };
  },
  computed: {
    gateId: function () {
      let arr = this.$store.state.order.gateIds ? this.$store.state.order.gateIds : [];
      let id = arr[0] ? arr[0].Id : undefined;
      return id;
    },
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      if (this.gateId && this.$refs.item) {
        this.$refs.item.server(true);
        this.form.OutGateId = this.videoGateId > -1 ? this.videoGateId :this.gateId;
        this.$refs.item.server(true);
        // this.$refs.carSizeSelect.server(true);
      }
    });
  },
  methods: {
    handleClick(){
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let res = await closeGate(this.form);
          if (res.state === "success") {
            this.$message.success(res.message);
            this.$emit("update:showdialog", false);
            this.handleClose();
            voicePrompt('一路平安');
          } else {
            this.$message.error(res.message);
          }
        }
      })
    },
    getItem(item) {
      this.form.ParkLotId = item.ParkLotId;
      this.form.OutGateId = item.Id;
      // this.form.OutGateId = item.Id;
    },
    handleClose() {
      this.$refs["form"].resetFields();
      this.$emit("update:showdialog", false);
    },
    getPlateNumber(v) {
      this.form.PlateNumber = v;
      this.$refs["form"].clearValidate();
    },
    getCarSizeItem() {
      // console.log('getCarSizeItem', obj)
    },
  },
};
</script>
